var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 22V12.5C25 11.4 24.1 10.5 23 10.5H17.5",
    stroke: "#FD9567",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.00146L17 10.5015L20 13.0015M11 14.0015V23.5015C11 24.6015 11.9 25.5015 13 25.5015H18.5M25 28.0015C25.7956 28.0015 26.5587 27.6854 27.1213 27.1228C27.6839 26.5602 28 25.7971 28 25.0015C28 24.2058 27.6839 23.4428 27.1213 22.8801C26.5587 22.3175 25.7956 22.0015 25 22.0015C24.2044 22.0015 23.4413 22.3175 22.8787 22.8801C22.3161 23.4428 22 24.2058 22 25.0015C22 25.7971 22.3161 26.5602 22.8787 27.1228C23.4413 27.6854 24.2044 28.0015 25 28.0015Z",
    stroke: "#FD9567",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.0015L19 25.5015L16 23.0015M11 14.0015C11.7956 14.0015 12.5587 13.6854 13.1213 13.1228C13.6839 12.5602 14 11.7971 14 11.0015C14 10.2058 13.6839 9.44275 13.1213 8.88014C12.5587 8.31754 11.7956 8.00146 11 8.00146C10.2044 8.00146 9.44129 8.31754 8.87868 8.88014C8.31607 9.44275 8 10.2058 8 11.0015C8 11.7971 8.31607 12.5602 8.87868 13.1228C9.44129 13.6854 10.2044 14.0015 11 14.0015Z",
    stroke: "#FD9567",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformation);
export default __webpack_public_path__ + "static/media/Transformation.c0642e3149d40a02fc353da10fe2bac9.svg";
export { ForwardRef as ReactComponent };